import React, { useState } from "react";
import { Box, TextField } from "@mui/material";

interface AddNameProps {
  name: string;
  setName: React.Dispatch<React.SetStateAction<string>>;
}

const AddName: React.FC<AddNameProps> = ({ name, setName }) => {
  const [inputValue, setInputValue] = useState<string>("");

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    // Ensure the input value is comma-separated
    const newValue = event.target.value
      .split(",") // Split by comma
      .map((item) => item.trim()) // Remove unnecessary spaces
      .filter((item) => item !== "") // Remove empty entries
      .join(", "); // Join them back with a comma and space

    setInputValue(newValue);
    setName(newValue); // Update the name state
  };

  console.log(inputValue, "inputValue");

  return (
    <Box>
      <TextField
        variant="standard"
        placeholder="Add New Type Name"
        value={inputValue}
        onChange={handleChange}
        autoComplete="off"
        sx={{
          minWidth: "unset !important",
          "& .MuiInputBase-root": { border: "none", maxWidth: "100%", overflow: "auto" },
          "& .MuiInput-underline:before": { border: "0 !important" },
          "& .MuiInput-underline:after": { borderBottom: "0 !important" },
          "& .MuiInputBase-input": { 
            color: "#B90022", 
            fontSize: "16px", 
            fontWeight: "600", 
            letterSpacing: "unset !important", 
            padding: "0" 
          },
          "&::placeholder": {
            color: "green",
            opacity: 1,
          },
        }}
      />
    </Box>
  );
};

export default AddName;
